import { List, Map, fromJS } from 'immutable';

export function request(state, { id, parameters }) {

    let tabUrl = state.get('tabUrl') || Map();
    state = state.setIn(['tabUrl', id], parameters);

    return state;
}
